import { Link } from 'react-router-dom';
import Icon from '@components/common/Icon';

const ExperienceSection = () => {
  return (
    <section
      className="py-16 sm:py-20 px-4 md:px-4"
      style={{ backgroundColor: 'var(--color-theme-2)' }}
    >
      <div className="container mx-auto max-w-7xl">
        <h2
          className="text-3xl sm:text-4xl font-heading font-bold text-center mb-8 sm:mb-12 tracking-tight"
          style={{ color: 'var(--color-heading)' }}
        >
          Experience & Research
        </h2>
        {/* Mobile: horizontal scroll, Desktop: grid */}
        <div className="md:grid md:grid-cols-2 md:gap-6 lg:gap-8 flex md:flex-none overflow-x-auto gap-4 snap-x snap-mandatory scrollbar-hide pb-4 md:pb-0 -mx-4 px-4 md:mx-0">
          {/* Professional Experience */}
          <Link to="/experienceandresearch" className="group h-full flex-shrink-0 w-[85vw] md:w-auto snap-center">
            <div
              className="h-full flex flex-col p-6 sm:p-8 rounded-xl border transition-all duration-200 hover:shadow-card-hover shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)'
              }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--color-theme-2)' }}
                >
                  <Icon name="experience" size="lg" style={{ color: 'var(--color-icon-default)' }} />
                </div>
                <h3
                  className="text-xl font-bold"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Professional Experience
                </h3>
              </div>
              <p
                className="mb-4 text-base"
                style={{ color: 'var(--color-card-text)' }}
              >
                Diverse internship experience in tech and robotics:
              </p>
              <ul className="text-sm space-y-3 mb-6 flex-1" style={{ color: 'var(--color-muted)' }}>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Albertsons Inc:</span> iPad app developer (2,000+ stores)</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Omind (USA):</span> AI Support Agent Developer</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Honda Manufacturing:</span> Robotics & Automation Intern</span>
                </li>
              </ul>
              <div
                className="font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1"
                style={{ color: 'var(--color-link)' }}
              >
                View Details →
              </div>
            </div>
          </Link>

          {/* Research */}
          <Link to="/experienceandresearch" className="group h-full flex-shrink-0 w-[85vw] md:w-auto snap-center">
            <div
              className="h-full flex flex-col p-6 sm:p-8 rounded-xl border transition-all duration-200 hover:shadow-card-hover shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)'
              }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--color-theme-2)' }}
                >
                  <Icon name="research" size="lg" style={{ color: 'var(--color-icon-default)' }} />
                </div>
                <h3
                  className="text-xl font-bold"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Research
                </h3>
              </div>
              <p
                className="mb-4 text-base"
                style={{ color: 'var(--color-card-text)' }}
              >
                Published research on AI in chess and game theory:
              </p>
              <ul className="text-sm space-y-3 mb-6 flex-1" style={{ color: 'var(--color-muted)' }}>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>AI in Chess:</span> Machine learning analysis</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Game Theory:</span> Strategic thinking research</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Technology:</span> Innovation intersection</span>
                </li>
              </ul>
              <div
                className="font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1"
                style={{ color: 'var(--color-link)' }}
              >
                Read Papers →
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
